__turbopack_context__.v({
  "tabItem": "tabUrl-module-scss-module__eNg-7a__tabItem",
  "tabItemSelected": "tabUrl-module-scss-module__eNg-7a__tabItemSelected",
});
